import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";

const TitlePage = ({
  children,
  variantPrimary = "h3",
  variantSecondary = "h4",
  align,
  color,
  gutterBottom,
  dataTour = "",
  sxContainer = {},
  sx = {},
}) => {
  const isMobile = useMediaQuery("(min-width:600px)");

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: {
          xs: 1,
          sm: 2,
        },
        flexDirection: "row",
        ...sxContainer,
      }}
    >
      <Typography
        align={align}
        color={color}
        variant={isMobile ? variantPrimary : variantSecondary}
        component="h1"
        gutterBottom={gutterBottom}
        sx={{
          fontWeight: 600,
          fontSize: { xs: "1.5rem", sm: "2.25rem" },
          ...sx,
        }}
        data-tour={dataTour}
      >
        {children}
      </Typography>
    </Box>
  );
};

export default TitlePage;
